import React, { useEffect, useState } from "react";
import "./CookieConsent.css";

const STORAGE_KEY = "masterSolCookieConsent";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const savedConsent = localStorage.getItem(STORAGE_KEY);

    if (!savedConsent) {
      setShowBanner(true);
      return;
    }

    try {
      const parsedConsent = JSON.parse(savedConsent);

      setPreferences({
        necessary: true,
        analytics: Boolean(parsedConsent.analytics),
        marketing: Boolean(parsedConsent.marketing),
      });
    } catch (error) {
      console.error("Invalid cookie preferences:", error);

      localStorage.removeItem(STORAGE_KEY);
      setShowBanner(true);
    }
  }, []);

  const savePreferences = (newPreferences) => {
    const consent = {
      necessary: true,
      analytics: Boolean(newPreferences.analytics),
      marketing: Boolean(newPreferences.marketing),
      savedAt: new Date().toISOString(),
    };

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(consent)
    );

    setPreferences(consent);
    setShowBanner(false);
    setShowSettings(false);

    window.dispatchEvent(
      new CustomEvent("cookieConsentChanged", {
        detail: consent,
      })
    );
  };

  const acceptAll = () => {
    savePreferences({
      necessary: true,
      analytics: true,
      marketing: true,
    });
  };

  const rejectAll = () => {
    savePreferences({
      necessary: true,
      analytics: false,
      marketing: false,
    });
  };

  const saveCustomPreferences = () => {
    savePreferences(preferences);
  };

  if (!showBanner && !showSettings) {
    return null;
  }

  return (
    <>
      {showBanner && (
        <div className="cookie-banner">
          <div className="cookie-banner-content">
            <div className="cookie-icon">
              🍪
            </div>

            <div className="cookie-text">
              <h2>Privatësia dhe Cookies</h2>

              <p>
                Ne përdorim cookies të nevojshme për
                funksionimin e faqes. Me pëlqimin tuaj,
                mund të përdorim gjithashtu cookies
                analitike dhe marketingu për të
                përmirësuar shërbimet dhe eksperiencën
                tuaj.
              </p>
            </div>

            <div className="cookie-actions">
              <button
                type="button"
                className="cookie-btn cookie-btn-reject"
                onClick={rejectAll}
              >
                Refuzo
              </button>

              <button
                type="button"
                className="cookie-btn cookie-btn-settings"
                onClick={() => setShowSettings(true)}
              >
                Personalizo
              </button>

              <button
                type="button"
                className="cookie-btn cookie-btn-accept"
                onClick={acceptAll}
              >
                Prano të gjitha
              </button>
            </div>
          </div>
        </div>
      )}

      {showSettings && (
        <div className="cookie-modal-overlay">
          <div className="cookie-modal">
            <div className="cookie-modal-header">
              <div>
                <span className="cookie-small-title">
                  MASTER SOL&TECH
                </span>

                <h2>Preferencat e cookies</h2>
              </div>

              <button
                type="button"
                className="cookie-close"
                onClick={() => setShowSettings(false)}
                aria-label="Mbyll"
              >
                ×
              </button>
            </div>

            <p className="cookie-modal-description">
              Ju mund të zgjidhni cilat kategori cookies
              dëshironi të lejoni. Cookies të nevojshme
              nuk mund të çaktivizohen sepse përdoren për
              funksionimin bazë dhe sigurinë e faqes.
            </p>

            <div className="cookie-category">
              <div>
                <h3>Cookies të nevojshme</h3>

                <p>
                  Përdoren për funksione bazë si siguria,
                  autentikimi dhe ruajtja e preferencave
                  teknike.
                </p>
              </div>

              <label className="cookie-switch disabled">
                <input
                  type="checkbox"
                  checked
                  disabled
                  readOnly
                />

                <span className="cookie-slider"></span>
              </label>
            </div>

            <div className="cookie-category">
              <div>
                <h3>Cookies analitike</h3>

                <p>
                  Na ndihmojnë të kuptojmë si përdoret
                  website-i dhe cilat faqe vizitohen më
                  shumë.
                </p>
              </div>

              <label className="cookie-switch">
                <input
                  type="checkbox"
                  checked={preferences.analytics}
                  onChange={(event) =>
                    setPreferences((current) => ({
                      ...current,
                      analytics: event.target.checked,
                    }))
                  }
                />

                <span className="cookie-slider"></span>
              </label>
            </div>

            <div className="cookie-category">
              <div>
                <h3>Cookies marketingu</h3>

                <p>
                  Mund të përdoren për matjen e
                  fushatave reklamuese dhe përmbajtje më
                  relevante.
                </p>
              </div>

              <label className="cookie-switch">
                <input
                  type="checkbox"
                  checked={preferences.marketing}
                  onChange={(event) =>
                    setPreferences((current) => ({
                      ...current,
                      marketing: event.target.checked,
                    }))
                  }
                />

                <span className="cookie-slider"></span>
              </label>
            </div>

            <div className="cookie-modal-actions">
              <button
                type="button"
                className="cookie-btn cookie-btn-reject"
                onClick={rejectAll}
              >
                Refuzo të gjitha
              </button>

              <button
                type="button"
                className="cookie-btn cookie-btn-accept"
                onClick={saveCustomPreferences}
              >
                Ruaj preferencat
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieConsent;